import React, { useState } from 'react';
import { ApIcon, ApButtonSecondary, colors } from '@alixpartners/ui-components';
import { SimpleTree } from 'components/SimpleTree';
import { SearchInput } from 'components/SearchInput';
import {
	Wrapper,
	DropdownLabel,
	LabelText,
	Footer,
	StyledMenu,
	Content,
	LabelHelper,
	NoData,
} from './CategoryTreeFilter.styles';
import { getTaxonomyTree } from 'Explore/CategorisationDialog/utils';

const getFlatTreeData = nodes => {
	if (!nodes) {
		return;
	}

	return nodes.reduce((acc, item) => {
		if (item.children && item.children.length > 0) {
			return [...acc, item, ...getFlatTreeData(item.children)];
		}

		return [...acc, item];
	}, []);
};

export const CategoryTreeFilter = ({ selectedItem, data, onChange }) => {
	const [isOpen, setOpen] = useState(false);
	const [treeQuery, setTreeQuery] = useState('');
	const [treeData, setTreeData] = useState(getTaxonomyTree(data));

	const toggleMenu = open => {
		setOpen(open);
	};

	const clear = () => {
		onChange(null);
		setTreeQuery('');
	};

	const handleTreeItemClick = node => {
		const newSelection =
			selectedItem && selectedItem.id === node.id ? null : node;

		onChange(newSelection);
		setTreeQuery('');
	};

	const handleSearchItemClick = node => {
		onChange(node);

		if (node) {
			setTreeQuery(node.id);
		}
	};

	const getSearchOptions = () => {
		if (!data) {
			return [];
		}

		return getFlatTreeData(treeData).map(({ name, id, level, data }) => ({
			name,
			value: name,
			id,
			level,
			info: `L${level}`,
			data,
		}));
	};

	const activeLabel = selectedItem ? selectedItem.name : 'All categories';

	return (
		<StyledMenu
			button={
				<div style={{ width: 'fit-content' }}>
					<DropdownLabel isOpen={isOpen}>
						<LabelText>{activeLabel}</LabelText>
						<LabelHelper>
							{selectedItem ? ` (L${selectedItem.level})` : ''}
						</LabelHelper>

						<ApIcon iconName="caret" iconColor={colors.grey5} />
					</DropdownLabel>
				</div>
			}
			placement="bottom-end"
			toggleMenu={toggleMenu}
			isOpen={isOpen}
		>
			<Wrapper>
				<SearchInput
					options={getSearchOptions()}
					onChange={handleSearchItemClick}
					placeholder="Search"
					charCount={2}
					showIcon
					isDismissible
				/>

				{data && data.length > 0 ? (
					<Content>
						<SimpleTree
							onTreeItemClick={handleTreeItemClick}
							onChange={setTreeData}
							selectedTreeItem={selectedItem}
							searchQuery={treeQuery}
							data={treeData}
							enableParentSelection
						/>
					</Content>
				) : (
					<NoData>No data available</NoData>
				)}

				<Footer>
					<ApButtonSecondary onClick={clear} disabled={!selectedItem} small>
						Clear
					</ApButtonSecondary>
				</Footer>
			</Wrapper>
		</StyledMenu>
	);
};

export default CategoryTreeFilter;
